module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.23.0@babel-runtime/core-js/json/stringify.js
// module id = 10
// module chunks = 0